import { useCallback, useMemo } from 'react';
import { isAfter, startOfDay } from 'date-fns';
import { InlineStartBillingMenuItem } from '../InlineStartBillingControl';
export const useMenuItems = (param)=>{
    let { isBilledUpfront, relationshipEffectiveDate, isAmendedService, getToday } = param;
    const isEffectiveDateInFuture = useMemo(()=>{
        if (relationshipEffectiveDate) {
            return isAfter(startOfDay(relationshipEffectiveDate), getToday());
        }
        return false;
    }, [
        relationshipEffectiveDate,
        getToday
    ]);
    const getAcceptanceDateOption = useCallback(()=>{
        if (!isBilledUpfront) {
            return null;
        }
        if (isAmendedService) {
            if (isEffectiveDateInFuture) {
                return {
                    value: InlineStartBillingMenuItem.AcceptanceDate,
                    menuText: 'Starting on agreement effective date',
                    selectedText: 'starting on agreement effective date',
                    description: "The service will be charged on the effective date of the agreement (even if it's not the set billing day) and continue issuing from the next scheduled billing day and going forward."
                };
            }
            return {
                value: InlineStartBillingMenuItem.Today,
                menuText: 'Starting today',
                selectedText: 'starting today',
                description: "The service will be charged once amendments are saved (even if it's not the set billing day) and continue issuing from the next scheduled billing day and going forward. Invoices including this service will require an approval from your client until this amendment is approved."
            };
        }
        if (isEffectiveDateInFuture) {
            return {
                value: InlineStartBillingMenuItem.AcceptanceDate,
                menuText: 'Starting on agreement effective date',
                selectedText: 'starting on agreement effective date',
                description: "The service will be charged on the effective date of the agreement (even if it's not the set billing day) and continue issuing from the next scheduled billing day and going forward."
            };
        }
        return {
            value: InlineStartBillingMenuItem.AcceptanceDate,
            menuText: 'Starting on proposal acceptance',
            selectedText: 'starting on proposal acceptance',
            description: "The service will be charged on the day the proposal is accepted (even if it's not the set billing day) and continue issuing from the next scheduled billing day and going forward."
        };
    }, [
        isBilledUpfront,
        isAmendedService,
        isEffectiveDateInFuture
    ]);
    const menuItems = useMemo(()=>{
        const items = [
            {
                value: InlineStartBillingMenuItem.NextBillingDay,
                menuText: 'Starting on the next scheduled billing date',
                selectedText: 'starting on the next scheduled billing date',
                description: 'Billing will start on the next scheduled billing date after the proposal is accepted.'
            },
            {
                value: InlineStartBillingMenuItem.SpecificDate,
                menuText: 'Starting on a specific date',
                selectedText: 'starting on',
                description: 'Choose a start date for automatic billing of this service. If the date has already passed or the proposal is accepted after that date, invoices for prior periods will be issued automatically.'
            }
        ];
        const acceptanceOption = getAcceptanceDateOption();
        if (acceptanceOption) {
            items.push(acceptanceOption);
        }
        items.push({
            value: InlineStartBillingMenuItem.ManualInitiation,
            menuText: 'Only after manual initiation',
            selectedText: 'only after manual initiation',
            description: 'The service will not be billed until you manually initiate automatic billing for it.'
        });
        return items;
    }, [
        getAcceptanceDateOption
    ]);
    return menuItems;
};
